import Api from "./Api.service";
export default class CosaTipoService {
    static ObtenerTodo() {
        return Api.get("cosatipo");
    }
}